import { createReducer } from '@reduxjs/toolkit';

import { QTaskComment } from '../models/Activity';
import { addTaskCommentToState, removeTaskCommentFromState, setTaskCommentLoading, updateTaskCommentsOnState } from 'data/actions/taskComments';

interface State {
  isLoading: boolean;
  comments: Array<QTaskComment>;
}

const initialState: State = {
  comments: [],
  isLoading: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(setTaskCommentLoading, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(updateTaskCommentsOnState, (state, action) => {
    if (!action.payload) return state;
    state.comments = [...action.payload].sort((a, b) => {
      const dateA = a.postDatetime ? new Date(a.postDatetime).getTime() : 0;
      const dateB = b.postDatetime ? new Date(b.postDatetime).getTime() : 0;
      return dateB - dateA;
    });
  });

  builder.addCase(addTaskCommentToState, (state, action) => {
    if (!action.payload) return state;
    state.comments = [action.payload, ...state.comments];
  });

  builder.addCase(removeTaskCommentFromState, (state, action) => {
    if (!action.payload) return state;
    state.comments = state.comments.filter(comment => comment.uuid !== action.payload);
  });
});
